module.exports = __webpack_public_path__ + "img/flip-horizontal.4229b44d.svg";